type Props = {
  label: string
  value: string
}

export const ProgramRequestOfferContentItem = ({
  label,
  value,
}: Props): JSX.Element => (
  <div className="flex flex-col">
    <div className="md:text-[0.9vw] text-[#666666]">{label}</div>
    <div className="md:mt-[0.8vw]">
      <div className="md:text-[1.3vw] text-[#333333]">{value}</div>
    </div>
  </div>
)
